import { memo } from "react";
import PropTypes from "prop-types";
import IconPin from "app/pages/.shared/icons/static/icons/IconPin";

/**
 * This component only pass required field and avoid warning described in this issue of google-map-react
 * @See https://github.com/google-map-react/google-map-react/issues/1015
 */
const MapPin = ({ style }) => {
	return <IconPin style={style} />;
};

MapPin.propTypes = { style: PropTypes.object };

export default memo(MapPin);
